import React from 'react';
import PropTypes from 'prop-types';
import { AccordionDetails } from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
} from '@mui/icons-material';

import { WarningTag } from '../Tags';

import {
  Title,
  StyledAccordion,
  StyledAccordionSummary,
  TitleContainer,
} from './styles';

const Accordion = ({
  title,
  label,
  defaultExpanded,
  children,
  expandIcon,
  preventRotation,
  actions,
  ...otherProps
}) => (
  <StyledAccordion
    defaultExpanded={defaultExpanded}
    {...otherProps}
  >
    <StyledAccordionSummary expandIcon={expandIcon} $preventrotation={preventRotation}>
      <TitleContainer>
        {typeof title === 'string' ? <Title>{title}</Title> : title}
        {!!label && <WarningTag>{label}</WarningTag>}
      </TitleContainer>
      {actions}
    </StyledAccordionSummary>
    <AccordionDetails>
      {children}
    </AccordionDetails>
  </StyledAccordion>
);

Accordion.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  label: PropTypes.string,
  defaultExpanded: PropTypes.bool,
  expandIcon: PropTypes.node,
  preventRotation: PropTypes.bool,
  children: PropTypes.node.isRequired,
  actions: PropTypes.node,
};

Accordion.defaultProps = {
  label: '',
  defaultExpanded: false,
  preventRotation: false,
  expandIcon: <ExpandMoreIcon />,
  actions: null,
};

export default Accordion;
